import { config, ThemeName } from 'appConfig';

export function isLeadzaiWhitelabel(userTheme: ThemeName): boolean {
  return userTheme === 'leadzai' || userTheme === 'default' || config.theme === 'leadzai';
}
